import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { MenuItemModel } from '../views/models/menu-item.model';
import { MenuTagModel } from '../views/models/menu-tag.model';
import { MenuTitleDescriptionModel } from '../views/models/menu-title-description.model';
import { MenuItemBulletListModel } from '../views/models/menu-item-bullet-list.model';
import { HttpClient } from '@angular/common/http';
import {MenuItemCapacity} from '../views/models/capacity.model';
import {environment} from '../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class ItemService {
  record_change$ = new BehaviorSubject<MenuItemModel>(new MenuItemModel());
  items_change$ = new BehaviorSubject<MenuItemModel[]>([]);
  tag_change$ = new BehaviorSubject<MenuTagModel[]>([]);
  titleDescription_change$ = new BehaviorSubject<MenuTitleDescriptionModel[]>([]);
  titleDescriptionHotel_change$ = new BehaviorSubject<MenuTitleDescriptionModel[]>([]);
  bulletList_change$ = new BehaviorSubject<MenuItemBulletListModel[]>([]);
  capacity_change$ = new BehaviorSubject<MenuItemCapacity[]>([]);


  constructor(private httpClient: HttpClient) {
  }

  getData(id: number, tableName: string) {
    this.httpClient.get(environment.baseURL + '/v2/api' + '/menu_item/' + id).subscribe(
      (data: MenuItemModel) => {
        this.record_change$.next(data);
      }
    );

    this.httpClient.get(environment.baseURL + '/v2/api' + '/title_description/' + id).subscribe(
      (datas: MenuTitleDescriptionModel[]) => {
        this.titleDescription_change$.next(datas);
      }
    );
    this.httpClient.get(environment.baseURL + '/v2/api' + '/bullet_list/' + id).subscribe(
      (datas: MenuItemBulletListModel[]) => {
        this.bulletList_change$.next(datas);
      }
    );

    this.httpClient.get(environment.baseURL + '/v2/api' + '/menu_tag/' + tableName + '/' + id).subscribe(
      (datas: MenuTagModel[]) => {
        this.tag_change$.next(datas);
      }
    );
  }

  getHotelTitleandDes(hotelid) {
    this.httpClient.get(environment.baseURL + '/v2/api' + '/title_description/1').subscribe(
      (datas: MenuTitleDescriptionModel[]) => {
        datas = datas.filter(x => x.hotel_id == hotelid);
        this.titleDescriptionHotel_change$.next(datas);
      }
    );

  }

  getItems() {
    this.httpClient.get(environment.baseURL + '/v2/api' + '/menu_item').subscribe(
      (datas: MenuItemModel[]) => {
        this.items_change$.next(datas);
      }
    );
  }

  getItemsWithSectionId(sectionId: number) {
    return new Promise((resolve, reject) => {
      this.httpClient.get(environment.baseURL + '/v2/api' + '/menu_item_section/' + sectionId).subscribe(resp => {
        resolve(resp);
      }, err => {
        reject(err);
      });
    });
  }

  putItem(data: MenuItemModel) {
    data.loyalty_max_point = +data.loyalty_max_point;
    data.loyalty_min_point = +data.loyalty_min_point;
    const itemArray = [data];
    this.httpClient.put(environment.baseURL + '/v2/api' + '/menu_item', itemArray).subscribe(
      () => {
      },
      error => console.log(error),
      () => this.getData(data.id, 'menu-item'));
  }

  setItem(data: MenuItemModel) {
    this.record_change$.next(data);
  }

  setTagDatas(data: MenuTagModel[]) {
    this.tag_change$.next(data);
  }

  postTagData(data: MenuTagModel) {
    this.httpClient.post(environment.baseURL + '/v2/api' + '/menu_tag', data).subscribe(
      () => {
      },
      error => console.log(error),
      () => this.getData(data.table_record_id, data.table_name)
    );
  }

  getBulletList() {
    const id = this.record_change$.getValue().id;
    this.httpClient.get(environment.baseURL + '/v2/api' + '/bullet_list/' + id).subscribe(
      (datas: MenuItemBulletListModel[]) => {
        this.bulletList_change$.next(datas);
      }
    );
  }

  postBulletListData(data: MenuItemBulletListModel) {
    data.menu_item_id = this.record_change$.getValue().id;
    this.httpClient.post(environment.baseURL + '/v2/api' + '/bullet_list', data).subscribe(
      () => {
      },
      error => console.log(error),
      () => {
        this.getBulletList();
      }
    );
  }

  putBulletListData(data: MenuItemBulletListModel) {
    data.menu_item_id = this.record_change$.getValue().id;
    this.httpClient.put(environment.baseURL + '/v2/api' + '/bullet_list/' + data.id, data).subscribe(
      () => {
      },
      (error) => {
        console.log(error);
      },
      () => {
        this.getBulletList();
      });
  }

  deleteTagData(id: number) {
    this.httpClient.delete(environment.baseURL + '/v2/api' + '/menu_tag/' + id).subscribe();
  }

  deleteBulletListData(id: number) {
    this.httpClient.delete(environment.baseURL + '/v2/api' + '/bullet_list/' + id).subscribe(
      () => this.getBulletList()
    );
  }

  getTitleAndDescription() {
    const menu_id = this.record_change$.getValue().id;
    this.httpClient.get(environment.baseURL + '/v2/api' + '/title_description/' + menu_id).subscribe(
      (datas: MenuTitleDescriptionModel[]) => {
        this.titleDescription_change$.next(datas);
      }
    );
  }

  postTitleDesData(data: MenuTitleDescriptionModel) {
    this.httpClient.post(environment.baseURL + '/v2/api' + '/title_description', data).subscribe(
      () => {
      },
      error => console.log(error),
      () => {
        this.getTitleAndDescription();
      }
    );
  }

  postTitleDesHotelData(data: MenuTitleDescriptionModel) {
    data.menu_item_id = 1;
    this.httpClient.post(environment.baseURL + '/v2/api' + '/title_description', data).subscribe(
      () => {
      },
      error => console.log(error),
      () => {
        this.getHotelTitleandDes(data.hotel_id);
      }
    );
  }

  putTitleDesData(data: MenuTitleDescriptionModel) {
    if (data.menu_item_id == 0) {
      data.menu_item_id = 1;
    }
    this.httpClient.put(environment.baseURL + '/v2/api' + '/title_description/' + data.id, data).subscribe(
      () => {
      },
      error => {
        console.log(error);
      },
      () => {
        if (data.hotel_id == 0) {
          this.getTitleAndDescription();
        } else {
          this.getHotelTitleandDes(data.hotel_id);
        }
      }
    );
  }

  deleteTitleDesData(item: MenuTitleDescriptionModel) {
    this.httpClient.delete(environment.baseURL + '/v2/api' + '/title_description/' + item.id).subscribe(
      () => {
        this.deleteFileonAWS(item);
        this.getTitleAndDescription();
        this.getHotelTitleandDes(item.hotel_id);
      }
    );
  }

  deleteFileonAWS(item: MenuTitleDescriptionModel) {
    this.httpClient.delete(environment.baseURL + '/v2/api' + '/uploaddocument?bucketname=b1development&directory=icibotV2/'
      + JSON.parse(localStorage.getItem('token_form')).app_hotel_id + '/TitleAndDescription/' + item.image_name)
      .subscribe();
  }

  postFile(selectedFile: File, tableName: string, baseData: any) {
    const fd = new FormData();
    fd.append('file', selectedFile, selectedFile.name);
    this.httpClient.post(environment.baseURL + '/v2/api' + '/uploaddocument?bucketname=b1development&directory=icibotV2/'
      + JSON.parse(localStorage.getItem('token_form')).app_hotel_id + '/TitleAndDescription/', fd)
      .subscribe((data: any) => {
        switch (tableName) {
          case 'titleDesc':
            baseData.image_url = data.link;
            baseData.image_name = data.link.split('/')[6];
            this.putTitleDesData(baseData);
            break;
        }
      },
        (err) => {
          console.log('Err : ' + err);
        }
      );
  }

  putData(data: MenuItemModel) {
    const changeValue: MenuItemModel[] = [data];
    console.log(changeValue);
    this.httpClient.put(environment.baseURL + '/v2/api' + '/menu_item', changeValue).subscribe(
      (resp) => {
        console.log(resp);
      },
      (err) => console.log(err),
      () => {
        this.record_change$.next(data);
      }
    );
  }

  getCapacities(id: number) {
    this.httpClient.get(environment.baseURL + '/v2/api' + '/menu_item_capacities/' + id).subscribe((resp: MenuItemCapacity[]) => {
      this.capacity_change$.next(resp);
    }, err => {
      console.log(err);
    });
  }

  postCapacities(id: number, data: MenuItemCapacity[]) {
    this.httpClient.post(environment.baseURL + '/v2/api' + '/menu_item_capacity', data).subscribe(() => {
      this.getCapacities(id);
    }, err => {
      console.log(err);
    });
  }

  putCapacities(data: MenuItemCapacity[]) {
    return new Promise((resolve, reject) => {
      this.httpClient.put(environment.baseURL + '/v2/api' + '/menu_item_capacity', data).subscribe((resp: MenuItemCapacity) => {
        resolve(resp);
      }, err => {
        reject(err);
        console.log(err);
      });
    });
  }

  deleteCapacity(id: number) {
    return new Promise((resolve, reject) => {
      this.httpClient.delete(environment.baseURL + '/v2/api' + '/menu_item_capacity/' + id).subscribe((resp: MenuItemCapacity) => {
        resolve(resp);
      }, err => {
        reject(err);
        console.log(err);
      });
    });
  }

  getCapacity(id: number) {
    return new Promise((resolve, reject) => {
      this.httpClient.get(environment.baseURL + '/v2/api' + '/menu_item_capacity/' + id).subscribe((resp: MenuItemCapacity) => {
        resolve(resp);
      }, err => {
        reject(err);
        console.log(err);
      });
    });
  }

}
